import axios from "axios";
import { Project, ProjectCategory, ProjectCategoryItem, ProjectProduct } from "models/project_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useFinanceProject = () => {
  const [list1, setList] = useState<Project[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [selectedOrder1, setSelectedOrder] = useState<Project>(null);
  const [show1, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [itens, setItens] = useState<ProjectCategory[]>([]);
  const [error, setError] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const cancelRef = useRef(null);
  const [initialProject, setInitialProject] = useState(false);
  const [loadingApprove, setLoadingApprove]  = useState(false);
  const [showApprove, setShowApprove] = useState(false);
  const cancelRascunho = useRef(null);

  const showModal1 = async (show: boolean, item: Project) => {
    if (show) {
      loadItens(item);
    } else{
      setSelectedOrder(null);
    }
    setShow(show);
  };

  const showModalApprove = (show: boolean) => {
    setShowApprove(show);
  }

  const cancelModalApprove = () => {
    setShowApprove(false);
  }

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const closeError = () => {
    setError(false);
  };

  const validate = () => {
    let retorno = true;
    if(selectedOrder1.metaEconomia === 0) {
      showError('Erro!', 'Você deve preencher  a meta de economia');
      retorno = false
    }
    if(Number(selectedOrder1.percentualProdutor) === 0) {
      showError('Erro!', 'Você deve preencher o percentual do produtor');
      retorno = false
    } 

    if(selectedOrder1.taxaEconomia === "") {
      showError('Erro!', 'Você deve preencher as instruções sobre ecônomia do projeto');
      retorno = false
    }

    return retorno;
  }

  const loadOrder = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const url = process.env.REACT_APP_API_URL + `/projeto/conciliacao/${userData?.idEmpresa}/0`;
    const response = await axios.get(url);
    if (response.data) {
      setList(response.data);
    }
  };

  const save = async () => {
    if(validate()) {
      setLoading(true);
      if(initialProject) {
        await insert();
      } else{
        await update();
      }
      setLoading(false);
      await loadOrder();
      setSelectedOrder(null);
      setShow(false);
    }
  }

  const insert = async () => {
    const data = { 
      id: selectedOrder1.id,
      idEmpresa: selectedOrder1.idEmpresa,
      orcamentoId: selectedOrder1.orcamentoId ,
      usuarioId: selectedOrder1.usuarioId,
      dataCriacao: selectedOrder1.dataCriacao,
      dataEdicao: selectedOrder1.dataEdicao,
      aprovado: selectedOrder1.aprovado ,
      aprovadoCalculo: selectedOrder1.aprovadoCalculo ,
      descricao: selectedOrder1.descricao, 
      linkDiretor: selectedOrder1.linkDiretor, 
      linkPastaExecutiva:selectedOrder1.linkPastaExecutiva, 
      linkPastaFinalizacao: selectedOrder1.linkPastaFinalizacao, 
      resumoCronograma: selectedOrder1.resumoCronograma, 
      linkCronograma: selectedOrder1.linkCronograma, 
      notasInternas: selectedOrder1.notasInternas, 
      notasClienteAgencia: selectedOrder1.notasClienteAgencia,
      notasFaturamento: selectedOrder1.notasFaturamento,
      status: selectedOrder1.status,
      metaEconomia: selectedOrder1.metaEconomia,
      reducaoGloblal: selectedOrder1.reducaoGloblal,
      valorReduzido: selectedOrder1.valorReduzido,
      limiteManejo: selectedOrder1.limiteManejo,
      valorManejo: selectedOrder1.valorManejo,
      taxaEconomia: selectedOrder1.taxaEconomia,
      valorEconomia: selectedOrder1.valorEconomia,
      percentualProdutor: selectedOrder1.percentualProdutor,
      retornoProdutor:selectedOrder1.retornoProdutor,

     };


      const response = await axios.patch(process.env.REACT_APP_API_URL + `/projeto/`+Number(selectedOrder1?.id), data);
  
      if (response.status === 200) {
        for (const categ of selectedOrder1?.ProjetoCategoria || []) {
          const dataItem = { 

            projetoId: categ.projetoId,
            descricao: categ.descricao,
            valor: categ.valor,
            orcado: categ.orcado,
            trabalhado: categ.trabalhado,
            executado: categ.executado,
            aprovado: categ.aprovado,
            metaReducao: categ.metaReducao,
            travado: categ.travado,
            porcentagemManejo: categ.porcentagemManejo,
            valorManejo: categ.valorManejo,
            porcentagemReducao: categ.porcentagemReducao,
            valorReducao: categ.valorReducao,
          };
          const categRequest = await axios.post(process.env.REACT_APP_API_URL + `/projeto/categoria`, dataItem);
  
          if (categRequest.data) {
            const id = categRequest.data;
  
            for (const itemCateg of categ.ProjetoItem || []) {
              const itemData = {
                projetoCategoriaId: id,
                produtoId: itemCateg.produtoId,
                descricao: itemCateg.descricao,
                unidadeMedidaId: itemCateg.unidadeMedidaId,
                quantidade: itemCateg.quantidade,
                valorUn: itemCateg.valorUn,
                valorTotal: itemCateg.valorTotal,
                orcado: itemCateg.orcado,
                trabalhado: itemCateg.trabalhado,
                executado: itemCateg.executado,
                usuarioId: itemCateg.usuarioId,
                aprovado: itemCateg.aprovado,
                metaReducao: itemCateg.metaReducao,
                travado: itemCateg.travado,
                porcentagemManejo: itemCateg.porcentagemManejo,
                valorManejo: itemCateg.valorManejo,
                porcentagemReducao: itemCateg.porcentagemReducao,
                valorReducao: itemCateg.valorReducao,
              };
              await axios.post(process.env.REACT_APP_API_URL + `/projeto/item`, itemData);
            }

            for(const val of categ.ProjetoProduto || []) {
              const projectProduct  = {
                descricao : val.descricao,
                novoProdutoId: val.novoProdutoId,
                projetoCategoriaId: id,
                quantidade: val.quantidade,
                valorTotal: val.valorTotal,
                valorUn: val.valorUn
              }
              await axios.post(process.env.REACT_APP_API_URL + `/projeto/produto`, projectProduct);
            }
          }
        }
      }

  };

  const update = async () => {
    const data = { 
      id: selectedOrder1.id,
      idEmpresa: selectedOrder1.idEmpresa,
      orcamentoId: selectedOrder1.orcamentoId ,
      usuarioId: selectedOrder1.usuarioId,
      dataCriacao: selectedOrder1.dataCriacao,
      dataEdicao: selectedOrder1.dataEdicao,
      aprovado: selectedOrder1.aprovado ,
      aprovadoCalculo: selectedOrder1.aprovadoCalculo ,
      descricao: selectedOrder1.descricao, 
      linkDiretor: selectedOrder1.linkDiretor, 
      linkPastaExecutiva:selectedOrder1.linkPastaExecutiva, 
      linkPastaFinalizacao: selectedOrder1.linkPastaFinalizacao, 
      resumoCronograma: selectedOrder1.resumoCronograma, 
      linkCronograma: selectedOrder1.linkCronograma, 
      notasInternas: selectedOrder1.notasInternas, 
      notasClienteAgencia: selectedOrder1.notasClienteAgencia,
      notasFaturamento: selectedOrder1.notasFaturamento,
      status: selectedOrder1.status,
      metaEconomia: selectedOrder1.metaEconomia,
      reducaoGloblal: selectedOrder1.reducaoGloblal,
      valorReduzido: selectedOrder1.valorReduzido,
      limiteManejo: selectedOrder1.limiteManejo,
      valorManejo: selectedOrder1.valorManejo,
      taxaEconomia: selectedOrder1.taxaEconomia,
      valorEconomia: selectedOrder1.valorEconomia,
      percentualProdutor: selectedOrder1.percentualProdutor,
      retornoProdutor:selectedOrder1.retornoProdutor,

     };

      const response = await axios.patch(process.env.REACT_APP_API_URL + `/projeto/${selectedOrder1?.id}`, data);
      if (response.status === 200) {
          const categRequest = await axios.delete(process.env.REACT_APP_API_URL + `/projeto/categoria/` + Number(selectedOrder1?.id));
          if (categRequest.data) {
  
            for (const itemCateg of selectedOrder1.ProjetoCategoria || []) {
              await axios.delete(process.env.REACT_APP_API_URL + `/projeto/item/` + itemCateg.id);
            }
          }
        }
        for (const categ of selectedOrder1?.ProjetoCategoria || []) {
          const dataItem = { 

            projetoId: categ.projetoId,
            descricao: categ.descricao,
            valor: categ.valor,
            orcado: categ.orcado,
            trabalhado: categ.trabalhado,
            executado: categ.executado,
            aprovado: categ.aprovado,
            metaReducao: categ.metaReducao,
            travado: categ.travado,
            porcentagemManejo: categ.porcentagemManejo,
            valorManejo: categ.valorManejo,
            porcentagemReducao: categ.porcentagemReducao,
            valorReducao: categ.valorReducao,
          };
          const categRequest = await axios.post(process.env.REACT_APP_API_URL + `/projeto/categoria`, dataItem);
  
          if (categRequest.data) {
            const id = categRequest.data;
  
            for (const itemCateg of categ.ProjetoItem || []) {
              const itemData = {
                projetoCategoriaId: id,
                produtoId: itemCateg.produtoId,
                descricao: itemCateg.descricao,
                unidadeMedidaId: itemCateg.unidadeMedidaId,
                quantidade: itemCateg.quantidade,
                valorUn: itemCateg.valorUn,
                valorTotal: itemCateg.valorTotal,
                orcado: itemCateg.orcado,
                trabalhado: itemCateg.trabalhado,
                executado: itemCateg.executado,
                usuarioId: itemCateg.usuarioId,
                aprovado: itemCateg.aprovado,
                metaReducao: itemCateg.metaReducao,
                travado: itemCateg.travado,
                porcentagemManejo: itemCateg.porcentagemManejo,
                valorManejo: itemCateg.valorManejo,
                porcentagemReducao: itemCateg.porcentagemReducao,
                valorReducao: itemCateg.valorReducao,
              };
              await axios.post(process.env.REACT_APP_API_URL + `/projeto/item`, itemData);
            }

            for(const val of categ.ProjetoProduto || []) {
              const projectProduct  = {
                descricao : val.descricao,
                novoProdutoId: val.novoProdutoId,
                projetoCategoriaId: id,
                quantidade: val.quantidade,
                valorTotal: val.valorTotal,
                valorUn: val.valorUn
              }
              await axios.post(process.env.REACT_APP_API_URL + `/projeto/produto`, projectProduct);
            }
          }
        }
      

  }

  const approve = async () => {

    const data = { 
      id: selectedOrder1.id,
      idEmpresa: selectedOrder1.idEmpresa,
      orcamentoId: selectedOrder1.orcamentoId ,
      usuarioId: selectedOrder1.usuarioId,
      dataCriacao: selectedOrder1.dataCriacao,
      dataEdicao: selectedOrder1.dataEdicao,
      aprovado: selectedOrder1.aprovado ,
      aprovadoCalculo: selectedOrder1.aprovadoCalculo ,
      descricao: selectedOrder1.descricao, 
      linkDiretor: selectedOrder1.linkDiretor, 
      linkPastaExecutiva:selectedOrder1.linkPastaExecutiva, 
      linkPastaFinalizacao: selectedOrder1.linkPastaFinalizacao, 
      resumoCronograma: selectedOrder1.resumoCronograma, 
      linkCronograma: selectedOrder1.linkCronograma, 
      notasInternas: selectedOrder1.notasInternas, 
      notasClienteAgencia: selectedOrder1.notasClienteAgencia,
      notasFaturamento: selectedOrder1.notasFaturamento,
      status: "1",
      metaEconomia: selectedOrder1.metaEconomia,
      reducaoGloblal: selectedOrder1.reducaoGloblal,
      valorReduzido: selectedOrder1.valorReduzido,
      limiteManejo: selectedOrder1.limiteManejo,
      valorManejo: selectedOrder1.valorManejo,
      taxaEconomia: selectedOrder1.taxaEconomia,
      valorEconomia: selectedOrder1.valorEconomia,
      percentualProdutor: selectedOrder1.percentualProdutor,
      retornoProdutor:selectedOrder1.retornoProdutor,

     };

      const response = await axios.patch(process.env.REACT_APP_API_URL + `/projeto/${selectedOrder1?.id}`, data);
      if (response.status === 200) {
          const categRequest = await axios.delete(process.env.REACT_APP_API_URL + `/projeto/categoria/` + Number(selectedOrder1?.id));
          if (categRequest.data) {
  
            for (const itemCateg of selectedOrder1.ProjetoCategoria || []) {
              await axios.delete(process.env.REACT_APP_API_URL + `/projeto/item/` + itemCateg.id);
            }
          }
        }
        for (const categ of selectedOrder1?.ProjetoCategoria || []) {
          const dataItem = { 

            projetoId: categ.projetoId,
            descricao: categ.descricao,
            valor: categ.valor,
            orcado: categ.orcado,
            trabalhado: categ.trabalhado,
            executado: categ.executado,
            aprovado: categ.aprovado,
            metaReducao: categ.metaReducao,
            travado: categ.travado,
            porcentagemManejo: categ.porcentagemManejo,
            valorManejo: categ.valorManejo,
            porcentagemReducao: categ.porcentagemReducao,
            valorReducao: categ.valorReducao,
          };
          const categRequest = await axios.post(process.env.REACT_APP_API_URL + `/projeto/categoria`, dataItem);
  
          if (categRequest.data) {
            const id = categRequest.data;
  
            for (const itemCateg of categ.ProjetoItem || []) {
              const itemData = {
                projetoCategoriaId: id,
                produtoId: itemCateg.produtoId,
                descricao: itemCateg.descricao,
                unidadeMedidaId: itemCateg.unidadeMedidaId,
                quantidade: itemCateg.quantidade,
                valorUn: itemCateg.valorUn,
                valorTotal: itemCateg.valorTotal,
                orcado: itemCateg.orcado,
                trabalhado: itemCateg.trabalhado,
                executado: itemCateg.executado,
                usuarioId: itemCateg.usuarioId,
                aprovado: itemCateg.aprovado,
                metaReducao: itemCateg.metaReducao,
                travado: itemCateg.travado,
                porcentagemManejo: itemCateg.porcentagemManejo,
                valorManejo: itemCateg.valorManejo,
                porcentagemReducao: itemCateg.porcentagemReducao,
                valorReducao: itemCateg.valorReducao,
              };
              await axios.post(process.env.REACT_APP_API_URL + `/projeto/item`, itemData);
            }
            for(const val of categ.ProjetoProduto || []) {
              const projectProduct  = {
                descricao : val.descricao,
                novoProdutoId: val.novoProdutoId,
                projetoCategoriaId: id,
                quantidade: val.quantidade,
                valorTotal: val.valorTotal,
                valorUn: val.valorUn
              }
              await axios.post(process.env.REACT_APP_API_URL + `/projeto/produto`, projectProduct);
            }
          }
        }
        await loadOrder();
        setSelectedOrder(null);
        setShow(false);
        setShowApprove(false);
  }

  const loadItens = (item: Project) => {
    if(item.ProjetoCategoria.length > 0) {
      setSelectedOrder(item);

    } else {
      console.log('value', item);
      
      const newProject:  Project = {
        ...item,
        ProjetoCategoria : item.Orcamento.OrcamentoCategoria.map((value) => {
          const projectCategory : ProjectCategory = {
           
            aprovado: false,
            descricao: value.descricao,
            executado: 0,
            metaReducao: 0, 
            orcado: 0,
            projetoId: item.id,
            trabalhado: 0, 
            travado: false,
            valor : value.valor,
            porcentagemManejo: '',
            porcentagemReducao: '',
            valorManejo: '0',
            valorReducao: '0',
            id: '',
            ProjetoItem: value.OrcamentoItem.map((val) => {
              const projectItem : ProjectCategoryItem = {
                id: "",
                projetoCategoriaId: "",
                produtoId: val.produtoId,
                descricao: val.descricao,
                unidadeMedidaId: val.unidadeMedidaId,
                quantidade: val.quantidade,
                valorUn: val.valorUn,
                valorTotal: val.valorTotal,
                orcado: 0,
                trabalhado: 0,
                executado: 0,
                usuarioId: usuario.id,
                aprovado: false,
                metaReducao: 0,
                travado: false,
                produtoNome: val.produtoNome,
                produtoUnidade: val.produtoUnidade,
                produtoUnidadeId: val.produtoUnidadeId,
                unidadeNome: val.unidadeNome,
                porcentagemManejo: '',
                porcentagemReducao: '',
                valorManejo: '0',
                valorReducao: '0',
              }
              return projectItem;
            }),
            ProjetoProduto: value?.OrcamentoProduto?.map((val) => {
              const projectProduct : ProjectProduct = {
                descricao : val.descricao,
                novoProdutoId: val.novoProdutoId,
                id: val.id,
                projetoCategoriaId: "",
                quantidade: val.quantidade,
                valorTotal: val.valorTotal,
                valorUn: val.valorUn
              }
              return projectProduct;
            }) || []
            
            
          }
          return projectCategory;
        
        })
      
      }
      setSelectedOrder(newProject);
      setInitialProject(true);
    }
  }
  const changeProject = (value: string, type: string, item: Project) => {
    switch (type) {
      case 'reducaoGlobal':
        item.reducaoGloblal = Number(value);
        break;
  
      case 'metaEconomia':
        item.metaEconomia = Number(value);
        break;
  
      case 'valorReduzido':
      case 'limiteManejo':
      case 'valorManejo':
      case 'taxaEconomia':
      case 'valorEconomia':
      case 'retornoProdutor':
      case 'percentualProdutor':
        
        item[type] = value;
        break;
    }
    setSelectedOrder(item);
  };

  const changeItem = (item: ProjectCategory) => {
    let total = 0;
    const newItems: ProjectCategory[] = itens.map((existingItem) => {
      if (existingItem.descricao === item.descricao) {
        return item;
      }
      return existingItem;
    });

    newItems.forEach((item) => {
      total = total + Number(item.valor);
    });
    setItens(newItems)
  }

  useEffect(() => {
    const loadOrder = async () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      setUsuario(userData);
      const url = process.env.REACT_APP_API_URL + `/projeto/conciliacao/${userData?.idEmpresa}/0`;
      const response = await axios.get(url);
      if (response.data) {
        setList(response.data);
      }
    };
    const loadData = async () => {
      await loadOrder();
    };
    loadData();
  }, []);

  return {
    list1,
    show1,
    selectedOrder1,
    showModal1,
    loading,
    save,
    changeItem,
    changeProject,
    error,
    errorMsg,
    errorTitle,
    closeError,
    cancelRef,
    approve,
    loadingApprove,
    showApprove,
    showModalApprove,
    cancelModalApprove,
    cancelRascunho
  };
};
export default useFinanceProject;
